import { IconSvg } from 'Components/shared/Icon/index.generated';
import { UserAvatar } from 'Components/shared/UserAvatar';
import { isEmpty } from 'lodash';
import React from 'react';
import { Button } from '~/lib/ui/button';
import { AVATAR_CONFIG } from '../../../../utils/avatar_dimensions';
import EntityBasicInfo from '../../../EntityBasicInfo';
import { EntityBasicInfoProps } from '../../../EntityBasicInfo/index.types';
import { useEntityInfo } from '../../hooks/useEntityInfo';
import { EntityProfileHeaderProps } from './index.types';

const { size, fontSize } = AVATAR_CONFIG.HEADER_DIMENSIONS;

export const EntityProfileHeader = ({
  unsavedContact,
  contacts,
  person,
  closePanel,
}: EntityProfileHeaderProps) => {
  const {
    name,
    phoneNumber,
    image,
    messageStatus,
    isInactive,
    conversationType,
    conversationDestination,
  } = useEntityInfo({
    unsavedContact,
    contacts,
    person,
  });

  const renderEntityAttribute = () => {
    const commonProps = {
      name: name || phoneNumber,
      messageStatus,
      isInactive,
      labels: [conversationType],
    } as EntityBasicInfoProps;

    if (!(conversationType === 'SMS' && !!unsavedContact)) {
      commonProps.labels.push(conversationDestination);
    }

    if (
      (!isEmpty(unsavedContact) && !contacts && !person) ||
      ((!isEmpty(person) || (!isEmpty(contacts) && !person)) && name)
    ) {
      return <EntityBasicInfo {...commonProps} />;
    }

    return null;
  };

  return (
    <>
      <div className="flex items-end justify-end">
        <Button
          variant="ghost"
          size="icon"
          className="p-0 hover:bg-transparent"
          onClick={closePanel}
        >
          {IconSvg['cross']}
        </Button>
      </div>

      <div className="flex items-center justify-center">
        <UserAvatar
          size={size}
          fontSize={fontSize}
          iconSize={AVATAR_CONFIG.getIconSize(size)}
          image={image}
          name={!isEmpty(contacts) || person ? name : undefined}
          isInactive={person?.deleted}
          key={`entity-profile-avatar-${person?.sourceId}`}
        />
      </div>

      {renderEntityAttribute()}
    </>
  );
};
